import React, { Component } from 'react';

import AuthModals from '../containers/AuthModals/AuthModals';
import ErrorModals from '../containers/ErrorModals/ErrorModals';
// import GifLoader from '../components/GifLoader';
import PageLayout from '../containers/PageLayout/PageLayout';
import stateUtils from '../utils/state';
import StoreConnector from './StoreConnector';
import StoreProvider from './StoreProvider';

const decorator = (ComposedComponent, headerOff = false, footerOff = false) => StoreProvider(
  (() => {
    class PageComponent extends Component {
      constructor(props) {
        super(props);
        this.state = {
          isPageReady: true,
        };
      }

      // todo: Set up sentry/error handling
      // todo: Set up Rerouting/Auth Routing
      // todo: Set up Socket

      render() {
        const { isPageReady } = this.state;

        return isPageReady ? (
          <PageLayout headerOff={headerOff} footerOff={footerOff}>
            <ComposedComponent />
            <AuthModals />
            <ErrorModals />
          </PageLayout>
        ) : (
          <div>Loading...</div>
        ); // <GifLoader />
      }
    }

    return StoreConnector(PageComponent, stateUtils.fullStateMap, {});
  })(),
);

export default decorator;
